import { render, staticRenderFns } from "./Translation.vue?vue&type=template&id=29bead48&scoped=true"
import script from "./Translation.vue?vue&type=script&lang=js"
export * from "./Translation.vue?vue&type=script&lang=js"
import style0 from "./Translation.vue?vue&type=style&index=0&id=29bead48&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bead48",
  null
  
)

export default component.exports